import { connect } from 'react-redux';
import Header from './Header';
import { userProfileRequest } from '../../store/actions/user.actions';
import { getUser } from '../../store/selectors/user.selector';
import { logo } from '../../store/selectors/auth.selector';

const mapDispatchToProps = { userProfileRequest: userProfileRequest };

const mapStateToProps = (state) => { 
    let user = getUser(state);
    const getLogo = logo(state);
    
    if (!user.length) {
        user = localStorage.getItem('user');
    }

    return { user, getLogo };
 };

export default connect(mapStateToProps, mapDispatchToProps)(Header);